import { lazy, Suspense } from 'react';
import { getGlossary } from '../../../../../services/Glossary';
import TooltipV2 from '../../../../TooltipV2';
import styles from './style.m.less';

// Lazily imported to break the circular dependency: RichText's feature registry statically
// imports this file, so importing RichText itself here has to happen outside that static graph.
const RichText = lazy(() => import(/* webpackChunkName: 'RichText' */ '../../../index'));

interface Props {
    keyword: string;
}

function GlossaryTermHighlight({ keyword }: Props) {
    const terms = getGlossary();
    const term = terms.find(t => t.keyword.toLowerCase() === keyword.toLowerCase());

    if (!term) {
        return keyword;
    }
    return (
        <TooltipV2
            tooltip={
                <Suspense fallback={<>Loading …</>}>
                    <RichText value={term.explanation} glossary={false} />
                </Suspense>
            }
            inline={true}
        >
            <span className={styles.term}>{keyword}</span>
        </TooltipV2>
    );
}

export default GlossaryTermHighlight;
